import React, { ReactNode, ChangeEvent, useState, RefObject, useEffect } from "react";
import AppIcon from "src/commun/composants/AppIcon";
import { AppFormErrorMessages } from "src/commun/composants/formulaire/AppFormErrorMessage/AppFormErrorMessage";
import styles from "./AppSelect.scss";
import { useAppText } from "src/commun/composants/AppText";

export type AppSelectOption = {
  value: string;
  label: string;
};

export const SELECTIONNER = "SELECTIONNER";

export type AppSelectProps = {
  options: AppSelectOption[] | undefined;
  value: string;
  name: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  onBlur: (event: ChangeEvent<HTMLSelectElement>) => void;
  onFocus?: (event: ChangeEvent<HTMLSelectElement>) => void;
  error?: string;
  touched?: boolean;
  fieldRef?: RefObject<HTMLDivElement>;
  conteneurStyle?: any;
  defaultValue?: string;
  children?: ReactNode;
  iconVerif?: boolean;
  stateManagementFromParent?: boolean;
  className?: string;
  disabled?: boolean;
} & React.ComponentProps<"select">;

const AppSelect = ({
  options,
  conteneurStyle,
  defaultValue,
  value,
  onChange,
  onBlur,
  error,
  touched,
  fieldRef,
  name,
  children,
  stateManagementFromParent = false,
  iconVerif = false,
  onFocus,
  className,
  disabled = false,
}: AppSelectProps) => {
  const [selectValue, setSelectValue] = useState((value && value !== "") ? value : defaultValue ? defaultValue : SELECTIONNER);
  const { tString } = useAppText();

  const changeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
    event.persist();
    setSelectValue(event.target.value);
    onChange(event);
  };

  const displayError = error && touched;

  useEffect(() => {
    if (!value || value === "") {
      setSelectValue(defaultValue ? defaultValue : SELECTIONNER);
    } else if (value !== selectValue) {
      setSelectValue(value);
    }
  }, [value]);

  return (
    <React.Fragment>
      <div className={styles.blockSelect}>
        <div
          ref={fieldRef}
          className={`${styles.conteneur} ${
            displayError ? styles.conteneurErreur : ""
          }`}
          style={conteneurStyle}
        >
          <select
            className={`${styles.champ} ${className} ${disabled && "btn__filter--disabled"}`}
            id={name}
            name={name}
            value={!stateManagementFromParent ? selectValue : value}
            onBlur={onBlur}
            onChange={changeHandler}
            onFocus={onFocus}
            disabled={disabled}
          >
            {defaultValue && (!value || value === "") && (
              <option value={defaultValue} disabled>
                {tString(defaultValue)}
              </option>
            )}

            {options &&
              options.map(option => (
                <option value={option.value} key={option.value}>
                  {option.label}
                </option>
              ))}
            {children}
          </select>
        </div>
        {iconVerif && touched && !error && (
          <AppIcon
            name="verification"
            className={
              conteneurStyle && conteneurStyle.overflow
                ? `${styles.selectIconVerif} ${styles.iconExterieur}`
                : styles.selectIconVerif
            }
            size="32px"
          />
        )}
      </div>
      {displayError && <AppFormErrorMessages erreurs={error} />}
    </React.Fragment>
  );
};

export default AppSelect;
